import { render, staticRenderFns } from "./SafetyEquipment2.vue?vue&type=template&id=0746b3e0&scoped=true"
import script from "./SafetyEquipment2.vue?vue&type=script&lang=js"
export * from "./SafetyEquipment2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0746b3e0",
  null
  
)

export default component.exports